module.exports = __webpack_public_path__ + "img/rac.043adf18.jpeg";